import { richardEmail } from '@/constants/emails';

export type NewsBlock =
  | {
      type: 'paragraph';
      content: string;
    }
  | {
      type: 'quote';
      content: string;
      tone?: 'sky' | 'slate';
    };

export type NewsArticle = {
  slug: string;
  title: string;
  authors: string;
  date: string;
  excerpt: string;
  heroVariant?: 'strategic-partnership';
  contactName?: string;
  contactEmail?: string;
  blocks: NewsBlock[];
};

export const newsArticles: NewsArticle[] = [
  {
    slug: 'docmoonlight-contrastconnect-strategic-collaboration',
    title:
      'DocMoonlight and ContrastConnect Announce Strategic Collaboration to Deliver the Industry’s Most Comprehensive Contrast Supervision Solution',
    authors: 'Ramez Morcos, MD, MBA and Dor Shoshan, MD',
    date: 'January 15, 2026',
    excerpt:
      'DocMoonlight and ContrastConnect announced a strategic collaboration built to deliver a more flexible and scalable contrast supervision solution for imaging organizations.',
    heroVariant: 'strategic-partnership',
    contactName: 'Richard Hanna',
    contactEmail: richardEmail,
    blocks: [
      {
        type: 'paragraph',
        content:
          "DocMoonlight, the nation's largest provider of onsite contrast supervision, and ContrastConnect, the largest provider of virtual contrast supervision, today announced a strategic collaboration designed to offer imaging organizations the most complete, flexible, and scalable contrast supervision solution in the industry. By aligning their complementary strengths, the partnership is aimed at expanding patient access, enhancing patient safety, and meeting growing imaging demands across diverse regulatory environments.",
      },
      {
        type: 'paragraph',
        content:
          "The collaboration brings together ContrastConnect's purpose-built virtual supervision platform, built to deliver real-time virtual contrast supervision with safety, redundancy, and reliability workflows not possible with standard telecommunication tools, and DocMoonlight's proven expertise in deploying high-quality onsite supervision, powered by a nationwide network of residents and fellows. Together, the companies will enable imaging centers to seamlessly utilize virtual or onsite supervision, or a combination of both, depending on state regulations, operational demands, and patient volumes.",
      },
      {
        type: 'quote',
        tone: 'sky',
        content:
          "Imaging organizations across the country are asking for dependable, scalable solutions that keep patients safe and operations efficient, said Dr. Morcos, CEO of DocMoonlight. By combining DocMoonlight's industry-leading onsite coverage with ContrastConnect's advanced virtual supervision capabilities, we're giving imaging organizations the flexibility and reliability they need across a variety of care and regulatory settings.",
      },
      {
        type: 'paragraph',
        content:
          "Through this partnership, imaging organizations gain access to one of the largest combined pools of supervising physicians while maintaining a consistent, unified coverage experience across markets. In states where virtual contrast supervision is not permitted, DocMoonlight's onsite teams will ensure compliant and uninterrupted coverage. Where virtual supervision is allowed, ContrastConnect's technology-enabled solution and distributed clinical team provide scalable coverage and operational efficiencies. Multi-state organizations can now rely on a coordinated supervision approach that adapts to regulatory differences without compromising patient access or coverage.",
      },
      {
        type: 'quote',
        tone: 'slate',
        content:
          "We're incredibly excited about what this collaboration means for the future of outpatient imaging, said Dr. Shoshan, CEO of ContrastConnect. Imaging volumes continue to grow, and organizations need coverage solutions that scale seamlessly with their operations. By bringing together ContrastConnect's virtual supervision ecosystem with DocMoonlight's onsite capabilities, we're helping imaging organizations serve more patients, more efficiently, across the country.",
      },
      {
        type: 'paragraph',
        content:
          'Together, DocMoonlight and ContrastConnect are setting a new standard for contrast supervision, delivering a flexible, patient-centered model that supports compliance, improves access to care, and scales effortlessly as imaging volumes continue to rise.',
      },
    ],
  },
];

export const getNewsArticleBySlug = (slug: string) =>
  newsArticles.find((article) => article.slug === slug);
